import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Timeline, TimelineLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";


export class ExtraFreespinView extends BaseView {

    private _wrapperSprite:PIXI.Sprite;
    private _addFsSpine:PIXI.spine.Spine;
    private _addTwoAnimation:string;
    private _animationDuration:number = 0;
    private _layer:ScalableLayer;

    constructor() {
        super();

        this._layer = StageManager.getLayer(WinterHoardLayerConfig.EXTRA_FS.name);
        this._layer.addChild(this);
    }

    protected initAnimations(): void {
        this.renderable = false;
        this._wrapperSprite = new PIXI.Sprite();
        this._wrapperSprite.anchor.set(0.5, 0.5);
        this._addFsSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("addExtraFs"));
        const animation:any = this._addFsSpine.skeleton.data.animations;
        this._addTwoAnimation = animation[0].name;
        this._animationDuration = animation[0].duration;

        //console.log("ADD EXTRA FREESPIN ANIMATIONS: ");
        //console.log(animation);

        this._wrapperSprite.addChild(this._addFsSpine);
        this.addChild(this._wrapperSprite);

        //this.playSpine();
    }

    public playSpine(track:number = 0, name:string = this._addTwoAnimation, loop:boolean = false, aborted:boolean = false): Timeline {
        const tl:TimelineLite = new TimelineLite();

        //debugger;
        if(!aborted) {
            //console.log("EXTRA FS PLAYING");
            tl.add([
                () => this.renderable = true,
                () => {
                this._addFsSpine.state.setAnimation(track, name, loop);
                }
            ]);
            tl.add(() => this.renderable = false, this._animationDuration);
        }

        return tl;
    }

    protected onResize(resizeData: IResizeData): void {

        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._wrapperSprite.position.set(370, 320);
        }
        else {
            this._wrapperSprite.position.set(370, 330);
        }
    }


}